import { Component, OnInit } from '@angular/core'; 
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { TableUtil } from 'src/app/tableUtil';

interface data
{
  value:string;
  viewValue: string;
}

@Component({
  selector: 'app-opspayments',
  templateUrl: './opspayments.component.html',
  styleUrls: ['./opspayments.component.css']
})

export class OpspaymentsComponent implements OnInit 
{
  constructor() { }

   custs:data[]=[
    {value:'FREEDOM-1',viewValue:'FREEDOM'},
    {value:'XOME-2',viewValue:'XOME'},
    {value:'PROTECK-3',viewValue:'PROTECK'},
    {value:'BK EMPOWER-4',viewValue:'BK EMPOWER'},
    {value:'FREEDOM XPANSE-5',viewValue:'FREEDOM XPANSE'},
   ];

   status:data[]=[
   {value:'Cancelled-1',viewValue:'Cancelled'},
   {value:'AchReady-1',viewValue:'AchReady'},
   {value:'Authorized-1',viewValue:'Authorized'},
   {value:'Cancellationfailed-1',viewValue:'Cancellation failed'},
   {value:'Completed-1',viewValue:'Completed'},
   {value:'Declined-1',viewValue:'Declined'},
   {value:'Error-1',viewValue:'Error'},
   {value:'Expired-1',viewValue:'Expired'},
   {value:'Rejected-1',viewValue:'Rejected'},
   {value:'Disputed-1',viewValue:'Disputed'},
  ];

  track:data[]=[
    {value:'First-1',viewValue:'First'},
    {value:'Second-1',viewValue:'Second'},
    {value:'Third-1',viewValue:'Third'},
  ];

  loan:data[]=[
    {value:'First-1',viewValue:'First'},
    {value:'Second-1',viewValue:'Second'},
    {value:'Third-1',viewValue:'Third'},
  ];

  borrower:data[]=[
    {value:'First-1',viewValue:'First'},
    {value:'Second-1',viewValue:'Second'},
    {value:'Third-1',viewValue:'Third'},
  ];

  card:data[]=[
    {value:'First-1',viewValue:'First'},
    {value:'Second-1',viewValue:'Second'},
    {value:'Third-1',viewValue:'Third'},
  ];

  address:data[]=[
    {value:'First-1',viewValue:'First'},
    {value:'Second-1',viewValue:'Second'},
    {value:'Third-1',viewValue:'Third'},
  ];
  
  city:data[]=[
    {value:'First-1',viewValue:'First'},
    {value:'Second-1',viewValue:'Second'},
    {value:'Third-1',viewValue:'Third'},
  ];

  state:data[]=[
    {value:'First-1',viewValue:'First'},
    {value:'Second-1',viewValue:'Second'},
    {value:'Third-1',viewValue:'Third'},
  ];

   
  firstFourDigit: any;
  lastFourDigit: any;
  // from: Date;
  // To: Date;
  
  public ShowFilters: boolean = true;
  public buttonName: any = 'Show Filters';

  toggle() {
    this.ShowFilters = !this.ShowFilters;
    if (this.ShowFilters)
      this.buttonName = "Hide Filters";
    else
      this.buttonName = "Show Filters";
  }

  ngOnInit(): void {

 
  }

  displayedColumns: string[] = ['Tracking', 'Loan', 'SettleDate', 'CardHolder','Card','SettleAmnt','BorrowerName','AppraisalAddr','Response','Appraiser','Lender','RefundStatus']
  dataSource = ELEMENT_DATA;
  reverseDataSource = [...ELEMENT_DATA].reverse();

  exportTable() {
    TableUtil.exportTableToExcel("ExampleMaterialTable");
  }
}

export interface PeriodicElement {
  Tracking: any;
  Loan: number;
  SettleDate: Date;
  CardHolder: string;
  Card:any;
  SettleAmnt: any;
  BorrowerName: string;
  AppraisalAddr: string;
  Response: any;
  Appraiser: any
  Lender: any;
  RefundStatus:any;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {Tracking: 1, Loan: 1234, SettleDate:new Date('11/11/2000'), CardHolder: 'abcd', Card:1234 ,SettleAmnt:'10000',BorrowerName:'xyz',AppraisalAddr:'pune',Response:'abcd',Appraiser:'abcd', Lender:'abcd',RefundStatus:'xyz'},
];
